export default __webpack_public_path__ + "static/media/circular_umd.8013c901.png";